import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalendarViewComponent } from './calendar-view/calendar-view.component';
import { CalendarComponent } from './calendar.component';
import { CasesComponent } from './cases/cases.component';
import { FacilitiesComponent } from './facilities/facilities.component';
import { RequestComponent } from './request/request.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { SchedulerCalendarComponent } from './scheduler-calendar/scheduler-calendar.component';

const routes: Routes = [
  {
    path: '',
    component: CalendarComponent,
    children: [
      {
        path: '',
        component: CalendarViewComponent
      },      
      {
        path: 'cases',
        component: CasesComponent
      },
      {
        path: 'scheduleList',
        component: ScheduleComponent
      },
      {
        path: 'SchedulerCalendar',
        component: SchedulerCalendarComponent
      },
      {
        path: 'request',
        component: RequestComponent
      },{
        path: 'facilities',
        component: FacilitiesComponent        
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class calendarRoutingModule { }
